import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Dropzone from 'react-dropzone'
import { connect } from 'react-redux'
import { clientSide } from '../../config_react.js'
import AddServices from './addServices.jsx'

import { HEADERS } from '../../../../../api/api'

const { redirectToStorage } = clientSide[0]

export default class dataTemplate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fileButtonDisplay: true,
            trashButtonDisplay: false,
            banButtonDisplay: false,
            bullhornButtonDisplay: false,
            openDropzone: false,
            addFileButtonRotated: false,
            loadingFile: false,
            localFileName: false,
            confirmButtonDisplay: false,
            cancelButtonDisplay: false,
            getListServicesDisplay: false,
            queDeleteFile: false,
            addServicesApp: null,
            delServicesApp: null,
            dappEth: null,
            typeServicesApp: null,
        }

        this.blockState = React.createRef()
        this.addFileButtonRef = React.createRef()
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.loading &&
            !this.state.loadingFile &&
            !this.props.value &&
            this.state.fileButtonDisplay
        ) {
            this.addFileButtonRef.current.style.backgroundColor = ''
        }

        if (this.props.isOpen !== prevProps.isOpen) {
            this.blockState.current.classList.toggle('dataTypeDropzone')
        }

        if (
            !this.blockState.current.classList.contains('dataTypeDropzone') &&
            !this.props.value &&
            this.state.fileButtonDisplay
        ) {
            this.addFileButtonRef.current.style.transform = 'rotate(0deg)'
        }

        if (
            this.state.dappEth !== null &&
            this.state.typeServicesApp !== null &&
            this.props.userPermissions
        ) {
            this.props.userPermissions.forEach(item => {
                if (item.dappAddress == this.state.dappEth) {
                    if (
                        this.state.typeServicesApp == 'add' &&
                        item.grantAccess &&
                        this.state.addServicesApp !== null
                    ) {
                        this.switchServicesInfoTimer()
                    } else if (
                        this.state.typeServicesApp == 'delete' &&
                        !item.grantAccess &&
                        this.state.delServicesApp !== null
                    ) {
                        this.switchServicesInfoTimer()
                    }
                }
            })
        }
    }

    onDrop = files => {
        this.changeAFButtonState()

        if (!files.length) {
            this.props.enableNotification('limitFileSize')
            return
        }

        this.props.loadingProcess()

        console.log(`/uploadfile:file`)
        console.log(files[0])
        const formData = new FormData()
        formData.append('file', files[0])
        formData.append('fileType', `${this.props.apiProperty}`)

        const options = {
            method: 'POST',
            body: formData,
            headers: HEADERS,
            credentials: 'include',
        }

        //delete options.headers['Content-Type']

        this.setState({
            loadingFile: !this.state.loadingFile,
            banButtonDisplay: !this.state.banButtonDisplay,
            fileButtonDisplay: !this.state.fileButtonDisplay,
        })

        fetch(`${redirectToStorage}/uploadfile`, options)
            .then(response => response.json())
            .then(response => {
                console.log(`return: /uploadfile`)
                console.log(response)
                if (response.ErrorCode) {
                    throw {
                        errorCode: response.ErrorCode,
                        errorMessage: response.ErrorMessage,
                    }
                } else if (!response.driveFileId) {
                    console.log(response)
                    throw {
                        errorMessage: 'File not uploaded',
                    }
                }
                return response
            })
            .then(response => {
                let { trashButtonDisplay, bullhornButtonDisplay } = this.state
                this.props.loadingProcess()
                this.props.updateData()
                this.setState({
                    fileButtonDisplay: !this.state.fileButtonDisplay,
                    loadingFile: !this.state.loadingFile,
                    localFileName: response.name,
                    banButtonDisplay: !this.state.banButtonDisplay,
                })

                if (trashButtonDisplay && bullhornButtonDisplay) {
                    this.setState({
                        trashButtonDisplay: !this.state.trashButtonDisplay,
                        bullhornButtonDisplay: !this.state
                            .bullhornButtonDisplay,
                    })
                }
            })
            .catch(err => {
                if (
                    err.errorCode === 500 &&
                    err.errorMessage ===
                        "The user's Drive storage quota has been exceeded."
                ) {
                    let {
                        trashButtonDisplay,
                        bullhornButtonDisplay,
                    } = this.state
                    this.props.loadingProcess()
                    this.props.updateData()

                    this.setState({
                        fileButtonDisplay: !this.state.fileButtonDisplay,
                        loadingFile: !this.state.loadingFile,
                        banButtonDisplay: !this.state.banButtonDisplay,
                    })

                    if (trashButtonDisplay && bullhornButtonDisplay) {
                        this.setState({
                            trashButtonDisplay: !this.state.trashButtonDisplay,
                            bullhornButtonDisplay: !this.state
                                .bullhornButtonDisplay,
                        })
                    }

                    this.props.enableNotification('limitCloudStorage')
                    return
                } else if (err.errorMessage === 'File not uploaded') {
                    let {
                        trashButtonDisplay,
                        bullhornButtonDisplay,
                    } = this.state
                    this.props.loadingProcess()
                    this.props.updateData()
                    console.log('Error: file not uploaded')

                    this.setState({
                        fileButtonDisplay: !this.state.fileButtonDisplay,
                        loadingFile: !this.state.loadingFile,
                        banButtonDisplay: !this.state.banButtonDisplay,
                    })

                    if (trashButtonDisplay && bullhornButtonDisplay) {
                        this.setState({
                            trashButtonDisplay: !this.state.trashButtonDisplay,
                            bullhornButtonDisplay: !this.state
                                .bullhornButtonDisplay,
                        })
                    }
                    return
                }
                throw Error(err.message).stack
            })
    }

    render() {
        return (
            <li
                ref={this.blockState}
                className={
                    this.props.value
                        ? 'dataTypeUploadFile dataType'
                        : 'dataType'
                }
            >
                {this.fileType()}
                {this.fileDescription()}
                {this.fileButton()}
                {this.addDropzone()}
                {this.banButton()}
                {this.trashButton()}
                {this.bullhornButton()}
                {this.confirmButton()}
                {this.cancelButton()}
                {this.getListServicesCloseButton()}
                {this.getListServices()}
            </li>
        )
    }

    fileType = () => {
        return (
            <div className="type_doc_container">
                <div className="type_doc_row">
                    <p className="typeDoc">{this.props.title}</p>
                </div>
            </div>
        )
    }

    fileDescription = () => {
        let retString = ''
        let { loadingFile, queDeleteFile, localFileName } = this.state
        let { translate } = this.props

        if (this.state.addServicesApp !== null) {
            retString = this.state.addServicesApp
        } else if (this.state.delServicesApp !== null) {
            retString = this.state.delServicesApp
        } else if (loadingFile) {
            retString = translate['Uploading...']
        } else if (queDeleteFile) {
            retString = translate['Are you sure you want to delete?']
        } else if (this.props.value) {
            retString = this.props.value
        } else if (localFileName) {
            retString = localFileName
        } else {
            retString = translate['The file will be displayed here']
        }

        return (
            <div className="des_doc_container">
                <div className="des_doc_row">
                    <p className="desDoc">{retString}</p>
                </div>
            </div>
        )
    }

    fileButton = () => {
        if (
            this.props.loading &&
            !this.props.value &&
            !this.state.loadingFile &&
            this.state.fileButtonDisplay
        ) {
            this.waitingLoading()
        }

        if (!this.state.fileButtonDisplay || this.props.value) return null

        return (
            <div className="plus">
                <label
                    ref={this.addFileButtonRef}
                    onClick={this.changeAFButtonState}
                >
                    <FontAwesomeIcon icon={'plus'} />
                </label>
            </div>
        )
    }

    waitingLoading = () => {
        this.addFileButtonRef.current.style.backgroundColor = 'rgba(#333438,1)'
    }

    trashButton = () => {
        if (!this.props.value || this.state.trashButtonDisplay) return null
        return (
            <div className="plus" onClick={this.trashButtonClicked}>
                <label>
                    <FontAwesomeIcon icon={'trash-alt'} />
                </label>
            </div>
        )
    }

    trashButtonClicked = () => {
        this.setState({
            trashButtonDisplay: !this.state.trashButtonDisplay,
            bullhornButtonDisplay: !this.state.bullhornButtonDisplay,
            confirmButtonDisplay: !this.state.confirmButtonDisplay,
            cancelButtonDisplay: !this.state.cancelButtonDisplay,
            queDeleteFile: !this.state.queDeleteFile,
        })
    }

    banButton = () => {
        if (!this.state.banButtonDisplay) return null
        return (
            <div className="plus-spinner" onClick={this.banButtonСancel}>
                <label>
                    <FontAwesomeIcon icon={'spinner'} />
                </label>
            </div>
        )
    }

    bullhornButton = () => {
        if (this.state.bullhornButtonDisplay || !this.props.value) return null
        return (
            <div className="bullhorn" onClick={this.bullhornClick}>
                <label>
                    <FontAwesomeIcon icon={'bullhorn'} />
                </label>
            </div>
        )
    }

    bullhornClick = () => {
        this.setState({
            trashButtonDisplay: !this.state.trashButtonDisplay,
            bullhornButtonDisplay: !this.state.bullhornButtonDisplay,
            getListServicesDisplay: !this.state.getListServicesDisplay,
        })
        this.blockState.current.classList.toggle('servicesList')
    }

    confirmButton = () => {
        if (!this.state.confirmButtonDisplay) return null
        return (
            <div className="bullhorn" onClick={this.conDeleteFile}>
                <label>
                    <FontAwesomeIcon icon={'check'} />
                </label>
            </div>
        )
    }

    conDeleteFile = () => {
        this.blockState.current.classList.remove('servicesList')
        this.blockState.current.classList.remove('dataTypeUploadFile')

        let { driveFileId, serialNumber, fileType } = this.props

        this.setState({
            banButtonDisplay: !this.state.banButtonDisplay,
            confirmButtonDisplay: !this.state.confirmButtonDisplay,
            cancelButtonDisplay: !this.state.cancelButtonDisplay,
            queDeleteFile: !this.state.queDeleteFile,
        })
        console.log(`/deletefile:driveFileId`)
        console.log(driveFileId)

        fetch(`${redirectToStorage}/deletefile`, {
            method: 'POST',
            headers: HEADERS,
            body: JSON.stringify({
                driveFileId: driveFileId,
            }),
            credentials: 'include',
        })
            .then(res => {
                console.log(`return: /deletefile`)
                console.log(res)
                this.setState({
                    banButtonDisplay: !this.state.banButtonDisplay,
                    localFileName: false,
                })
                this.props.updateData()
            })
            .catch(error => {
                console.log(error)
            })
    }

    cancelButton = () => {
        if (!this.state.cancelButtonDisplay) return null
        return (
            <div className="plus" onClick={this.trashButtonClicked}>
                <label>
                    <FontAwesomeIcon icon={'times'} />
                </label>
            </div>
        )
    }

    changeAFButtonState = () => {
        if (this.props.loading) {
            return null
        }
        this.props.toogleOpen()
    }

    addDropzone = () => {
        if (!this.props.isOpen) return null

        this.addFileButtonRef.current.style.transform = 'rotate(45deg)'
        return (
            <Dropzone
                className="dropzone"
                onDrop={files => this.onDrop(files)}
                multiple={false}
                maxSize={5000000}
            >
                <p>
                    {
                        this.props.translate[
                            'Drop the file here or click to upload'
                        ]
                    }
                </p>
            </Dropzone>
        )
    }

    getListServicesCloseButton = () => {
        if (!this.state.getListServicesDisplay) return null
        return (
            <div className="plus" onClick={this.bullhornClick}>
                <label>
                    <FontAwesomeIcon icon={'times'} />
                </label>
            </div>
        )
    }

    switchServicesInfo = (type, serName, dappEthAddress) => {
        let { translate } = this.props
        let grantedAccess = translate['* service is granted access']
        let nGrantedAccess = translate['* service is not granted access']

        this.setState({
            dappEth: dappEthAddress,
            typeServicesApp: type,
        })

        if (type == 'add') {
            this.setState({
                delServicesApp: null,
                addServicesApp: `${grantedAccess}`.replace(/(\*)/g, serName),
            })
        } else if (type == 'delete') {
            this.setState({
                addServicesApp: null,
                delServicesApp: `${nGrantedAccess}`.replace(/(\*)/g, serName),
            })
        }
    }

    switchServicesInfoTimer = () => {
        this.setState({
            addServicesApp: null,
            delServicesApp: null,
        })
    }

    getListServices = () => {
        if (!this.state.getListServicesDisplay) return null
        let {
            driveFileId,
            serialNumber,
            fileType,
            userPermissions,
        } = this.props
        return (
            <AddServices
                servicesList={this.props.servicesList}
                userPermissions={userPermissions}
                driveFileId={driveFileId}
                updateData={this.props.updateData}
                switchServicesInfo={this.switchServicesInfo}
                switchServicesInfoTimer={this.switchServicesInfoTimer}
            />
        )
    }
}
